const AFF_STORAGE_KEY = 'mateo_aff_code';
const AFF_TIMESTAMP_KEY = 'mateo_aff_ts';
const AFF_VISITOR_KEY = 'mateo_aff_visitor_id';
const AFF_EXPIRY_DAYS = 30;

/**
 * Capture affiliate code from URL and store in localStorage
 */
export function captureAffiliateCode(): string | null {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('aff');
  if (code) {
    localStorage.setItem(AFF_STORAGE_KEY, code);
    localStorage.setItem(AFF_TIMESTAMP_KEY, Date.now().toString());
  }
  return code;
}

/**
 * Get or create a session-level visitor ID for anonymous click tracking.
 * Stored in sessionStorage so it persists across page navigations
 * but expires when the browser tab closes.
 */
export function getOrCreateVisitorId(): string {
  let visitorId = sessionStorage.getItem(AFF_VISITOR_KEY);
  if (!visitorId) {
    visitorId = crypto.randomUUID();
    sessionStorage.setItem(AFF_VISITOR_KEY, visitorId);
  }
  return visitorId;
}

/**
 * Get stored visitor ID (if exists)
 */
export function getStoredVisitorId(): string | null {
  return sessionStorage.getItem(AFF_VISITOR_KEY);
}

/**
 * Get stored affiliate code (if not expired)
 */
export function getStoredAffiliateCode(): string | null {
  const code = localStorage.getItem(AFF_STORAGE_KEY);
  const ts = localStorage.getItem(AFF_TIMESTAMP_KEY);
  if (!code || !ts) return null;

  const elapsed = Date.now() - parseInt(ts, 10);
  if (elapsed > AFF_EXPIRY_DAYS * 24 * 60 * 60 * 1000) {
    clearAffiliateCode();
    return null;
  }
  return code;
}

/**
 * Clear stored affiliate code after conversion
 */
export function clearAffiliateCode(): void {
  localStorage.removeItem(AFF_STORAGE_KEY);
  localStorage.removeItem(AFF_TIMESTAMP_KEY);
}
